<form class="g-3 needs-validation" novalidate [formGroup]="frmFields" (ngSubmit)="onSubmit(content,referral)">
    <div class="row" *ngIf="premiums">
        <div class="col-md-8">

            <h4>Quote Summary</h4>
            <div class="form_sections" style="min-height: 411px;">
                <div class="row">
                    <div class="col-md-5 fw-300">Compulsory Excess</div>
                    <div class="col-md-7 fw-500">£{{ premiums.compulsory_excess }} {{ comp_cover_type }}</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Additional Vehicle Excess</div>
                    <div class="col-md-7 fw-500">None</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Voluntary Excess <span class="ml-1"
                            (click)="helpTextPopup(content,'Please note this will apply in addition to any compulsory, vehicle or driver excesses that may apply.')"><i
                                class="mdi mdi-comment-question-outline"></i></span></div>
                    <div class="col-md-7">
                        <mat-form-field class="w-100" *ngIf="staticData">
                            <mat-label>Voluntary Excess</mat-label>
                            <mat-select formControlName="voluntary_excess" class="form-control form-control-sm"
                                name="voluntary_excess" required (selectionChange)="calculatePremium()"
                                [ngClass]="{ 'is-invalid': (f.voluntary_excess.touched || submitted) && f.voluntary_excess.errors?.required }">
                                <mat-option [value]="v" *ngFor="let v of staticData.voluntary_excess_options">
                                    &pound;{{ v }}
                                </mat-option>
                            </mat-select>
                            <div class="invalid-feedback"
                                *ngIf="(f.voluntary_excess.touched || submitted) && f.voluntary_excess.errors?.required">
                                Please select an option.
                            </div>
                        </mat-form-field>
                    </div>
                </div>
                <!-- <div class="row mt-2">
                    <div class="col-md-5 fw-300">Peliwica Fee</div>
                    <div class="col-md-7">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text dark-green-bg text-white">&pound;</span>
                                </div>
                                <input type="text" class="form-control form-control-sm" placeholder="Peliwica Fee"
                                    name="peliwica_fee" formControlName="peliwica_fee" readonly>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="row mt-3">
                    <div class="col-md-12">
                        <span class="fw-500">Young & inexperienced driver excess</span> (does not apply to
                        Agricultural
                        vehicles)
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5">
                        Where driver is aged 21 years or below
                    </div>
                    <div class="col-md-7">
                        &pound;250
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5">
                        Where driver is aged 22-24 years
                    </div>
                    <div class="col-md-7">
                        &pound;250
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5">
                        Where a driver aged 25 years or more has not held their full relevant UK/EU driving
                        license at
                        least 12 months
                    </div>
                    <div class="col-md-7">
                        &pound;250
                    </div>
                </div>
            </div>

            <div *ngIf="breakdown_premiums_arr && breakdown_premiums_arr.length > 0">
                <h4 class="mt-2">Breakdown Cover</h4>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form_sections">
                            <p class="fw-300">Would you like to add breakdown cover to the quote?</p>
                            <div *ngFor="let mv of modelObj.vehicles;">
                                <div *ngFor="let v of breakdown_premiums_arr; let i = index;">
                                    <div class="row mt-3" *ngIf="v.registration_number == mv.registration_number">
                                        <div class="col-md-5 fw-300">{{ v.registration_number }} (£{{ v.value }})</div>
                                        <div class="col-md-7">
                                            <mat-radio-group class="row" aria-label="Select an option"
                                                name="breakdown_cover_{{i}}"
                                                (change)="onBreakdownSelection($event, v.registration_number)" required>
                                                <div class="col-md-4">
                                                    <div class="quote_radio w-90">
                                                        <mat-radio-button name="breakdown_cover" [value]="true"
                                                            [checked]="mv.breakdown_cover == true">Yes
                                                        </mat-radio-button>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="quote_radio w-90">
                                                        <mat-radio-button name="breakdown_cover" [value]="false"
                                                            [checked]="mv.breakdown_cover == false">No
                                                        </mat-radio-button>
                                                    </div>
                                                </div>
                                            </mat-radio-group>
                                            <div class="invalid-feedback" style="font-size: 13px;"
                                                *ngIf="(f.breakdown_cover.touched || submitted) && f.breakdown_cover.errors?.required">
                                                Please select an option.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngFor="let v of modelObj.vehicles; let i = index;">

                                <div class="mt-3" *ngIf="v.owner">
                                    <p class="fw-300 mt-3" *ngIf="i == 0">Please provide details of the registered owner
                                        for the following
                                        vehicles;</p>
                                    <div class="row">
                                        <div class="col-md-5 fw-300">{{ v.registration_number }}</div>
                                        <div class="col-md-5">
                                            <input type="text" class="form-control form-control-sm" required
                                                [(ngModel)]="v.owner_name" [ngModelOptions]="{standalone: true}"
                                                name="owner_name_{{i}}" #ownerName="ngModel"
                                                (ngModelChange)="onOwnerNameChange($event, v.id)"
                                                [ngClass]="{ 'is-invalid': (ownerName.touched || submitted) && ownerName.errors?.required }">
                                            <div class="invalid-feedback"
                                                *ngIf="(ownerName.touched || submitted) && ownerName.errors?.required">
                                                Please enter the details.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- SADDLERY & TACK COVER SECTION -->
            <div class="mt-4" *ngIf="showAmlinAddonProducts && (isNewQuote || !isQuoteComplete) && !sdtkQuoteId">
                <h4>Saddlery & Tack Cover</h4>
                <div class="form_sections">
                    <div class="row">
                        <div class="col-md-12">
                            <mat-checkbox formControlName="include_sdtk"
                                (change)="onIncludeSDTKChange($event.checked)">
                                Add Saddlery & Tack Cover to this quote
                            </mat-checkbox>
                        </div>
                    </div>
                    <div *ngIf="includeSDTK" class="mt-3">
                        <div class="green_border_panel">
                            <div class="row align-items-center">
                                <div class="col-md-5">
                                    <h6 class="text-white mb-0">Select Cover Option <span class="text-danger">*</span></h6>
                                </div>
                                <div class="col-md-7">
                                    <mat-form-field class="w-100 sdtk-select-field">
                                        <mat-label>Saddlery & Tack Cover</mat-label>
                                        <mat-select formControlName="sdtk_option_id" required
                                            (selectionChange)="onSdtkOptionChange($event)"
                                            [ngClass]="{ 'is-invalid': (f.sdtk_option_id.touched || submitted) && f.sdtk_option_id.errors?.required }">
                                            <mat-option *ngFor="let opt of sdtkOptions" [value]="opt.id">
                                                {{ opt.name }} - &pound;{{ opt.total_premium_incl_ipt | number:'1.2-2' }}
                                            </mat-option>
                                        </mat-select>
                                        <div class="invalid-feedback"
                                            *ngIf="(f.sdtk_option_id.touched || submitted) && f.sdtk_option_id.errors?.required">
                                            Please select a cover option.
                                        </div>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <!-- Premium Breakdown -->
                        <div class="row mt-3" *ngIf="selectedSdtkOption">
                            <div class="col-md-12">
                                <div class="sdtk-premium-summary">
                                    <div class="row">
                                        <div class="col-md-3 text-center sdtk-premium-summary__item">
                                            <div class="sdtk-premium-summary__label">Sum Insured</div>
                                            <div class="sdtk-premium-summary__value">&pound;{{ selectedSdtkOption.sum_insured | number:'1.2-2' }}</div>
                                        </div>
                                        <div class="col-md-3 text-center sdtk-premium-summary__item">
                                            <div class="sdtk-premium-summary__label">Premium (excl IPT)</div>
                                            <div class="sdtk-premium-summary__value">&pound;{{ sdtkAdjustedPremiumExclIpt | number:'1.2-2' }}</div>
                                        </div>
                                        <div class="col-md-3 text-center sdtk-premium-summary__item">
                                            <div class="sdtk-premium-summary__label">IPT</div>
                                            <div class="sdtk-premium-summary__value">&pound;{{ sdtkAdjustedIpt | number:'1.2-2' }}</div>
                                        </div>
                                        <div class="col-md-3 text-center sdtk-premium-summary__item sdtk-premium-summary__item--total">
                                            <div class="sdtk-premium-summary__label">Total (incl IPT)</div>
                                            <div class="sdtk-premium-summary__value">&pound;{{ sdtkAdjustedTotalInclIpt | number:'1.2-2' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- S&T Questions -->
                        <div class="mt-3">
                            <h5>Saddlery & Tack Questions</h5>

                            <!-- Has items over £1500 -->
                            <div class="green_border_panel mt-2">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h6 class="text-white">Do you have any items valued at &pound;1500 or over?</h6>
                                        <mat-radio-group class="row" formControlName="sdtk_has_items_over_1500"
                                            (change)="onSdtkHighValueChange($event)">
                                            <div class="col-md-4">
                                                <div class="quote_radio w-90">
                                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="quote_radio w-90">
                                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                                </div>
                                            </div>
                                        </mat-radio-group>
                                    </div>
                                </div>

                                <!-- High Value Items List -->
                                <div class="text-white mt-3" *ngIf="frmFields.get('sdtk_has_items_over_1500')?.value === true">
                                    <h6>Please provide details of each item and confirm the market value</h6>
                                    <small>Note that the total value of the specified items is included within the cover limit you have selected above, not in addition to it.</small> -->

                                    <div formArrayName="sdtk_high_value_items" class="mt-3">
                                        <div *ngFor="let item of sdtkHighValueItems.controls; let i = index" [formGroupName]="i" class="mb-4">
                                            <div class="row mb-2">
                                                <div class="col-md-12">
                                                    <h6 class="text-white"><strong>Item {{i + 1}}</strong></h6>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-md-4">
                                                    <label class="text-white">Make</label>
                                                    <input type="text" class="form-control form-control-sm" placeholder="Enter make" formControlName="make" required
                                                        [ngClass]="{ 'is-invalid': (item.get('make').touched || submitted) && item.get('make').errors?.required }">
                                                    <div class="invalid-feedback" *ngIf="(item.get('make').touched || submitted) && item.get('make').errors?.required">Make is required.</div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label class="text-white">Model</label>
                                                    <input type="text" class="form-control form-control-sm" placeholder="Enter model" formControlName="model" required
                                                        [ngClass]="{ 'is-invalid': (item.get('model').touched || submitted) && item.get('model').errors?.required }">
                                                    <div class="invalid-feedback" *ngIf="(item.get('model').touched || submitted) && item.get('model').errors?.required">Model is required.</div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label class="text-white">Type</label>
                                                    <input type="text" class="form-control form-control-sm" placeholder="Enter type" formControlName="type" required
                                                        [ngClass]="{ 'is-invalid': (item.get('type').touched || submitted) && item.get('type').errors?.required }">
                                                    <div class="invalid-feedback" *ngIf="(item.get('type').touched || submitted) && item.get('type').errors?.required">Type is required.</div>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-md-4">
                                                    <label class="text-white">Colour</label>
                                                    <input type="text" class="form-control form-control-sm" placeholder="Enter colour" formControlName="colour" required
                                                        [ngClass]="{ 'is-invalid': (item.get('colour').touched || submitted) && item.get('colour').errors?.required }">
                                                    <div class="invalid-feedback" *ngIf="(item.get('colour').touched || submitted) && item.get('colour').errors?.required">Colour is required.</div>
                                                </div>
                                                <div class="col-md-4">
                                                    <label class="text-white">Size</label>
                                                    <input type="text" class="form-control form-control-sm" placeholder="Enter size" formControlName="size" required
                                                        [ngClass]="{ 'is-invalid': (item.get('size').touched || submitted) && item.get('size').errors?.required }">
                                                    <div class="invalid-feedback" *ngIf="(item.get('size').touched || submitted) && item.get('size').errors?.required">Size is required.</div>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="text-white">Value</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text">&pound;</span>
                                                        </div>
                                                        <input type="number" class="form-control form-control-sm" placeholder="Value" formControlName="value" required
                                                            [ngClass]="{ 'is-invalid': (item.get('value').touched || submitted) && (item.get('value').errors?.required || item.get('value').errors?.min) }">
                                                        <div class="invalid-feedback" *ngIf="(item.get('value').touched || submitted) && item.get('value').errors?.required">Value is required.</div>
                                                        <div class="invalid-feedback" *ngIf="(item.get('value').touched || submitted) && item.get('value').errors?.min">Min &pound;1500.</div>
                                                    </div>
                                                </div>
                                                <div class="col-md-1 d-flex align-items-end">
                                                    <a (click)="removeSdtkItem(i)" class="btn btn-danger btn-sm p-1" *ngIf="sdtkHighValueItems.controls.length > 1">
                                                        <i class="mdi mdi-delete"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <hr class="bg-white" *ngIf="i < sdtkHighValueItems.controls.length - 1">
                                        </div>
                                    </div>

                                    <!-- Total Value Warning -->
                                    <div class="alert alert-danger mt-2" *ngIf="isSdtkTotalOverLimit()">
                                        <strong>Warning:</strong> Total value of specified items (&pound;{{sdtkTotalHighValueItems}}) exceeds the selected cover limit (&pound;{{sdtkCoverLimitSelected}}). Please adjust your items or increase your cover limit.
                                    </div>

                                    <!-- Add Another Item -->
                                    <a (click)="addSdtkItem()" class="btn btn-default btn-success btn-sm f-12 mt-2">
                                        Click here if you wish to add another item
                                    </a>
                                </div>
                            </div>

                            <!-- Is legal owner -->
                            <div class="green_border_panel mt-3">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h6 class="text-white">Is the policyholder the legal owner of the saddlery and tack?</h6>
                                        <mat-radio-group class="row" formControlName="sdtk_is_legal_owner">
                                            <div class="col-md-4">
                                                <div class="quote_radio w-90">
                                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="quote_radio w-90">
                                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                                </div>
                                            </div>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>

                            <!-- Storage location -->
                            <div class="green_border_panel mt-3">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h6 class="text-white mb-3">Where is the saddlery and tack usually stored?</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4" *ngFor="let opt of sdtkStorageOptions">
                                        <div class="sdtk-storage-card"
                                            [class.sdtk-storage-card--selected]="frmFields.get('sdtk_storage_location').value === opt.id"
                                            (click)="frmFields.get('sdtk_storage_location').setValue(opt.id); onSdtkStorageChange({value: opt.id})">
                                            <i class="mdi" [ngClass]="opt.icon" style="font-size: 36px;"></i>
                                            <span class="sdtk-storage-card__label">{{ opt.label }}</span>
                                            <small class="sdtk-storage-card__desc">{{ opt.description }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2" *ngIf="frmFields.get('sdtk_storage_location').value === 2">
                                    <div class="sdtk-storage-note">
                                        <i class="mdi mdi-information-outline"></i>
                                        <span>A 25% loading will apply to your premium for shipping container storage.</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Agreement checkboxes -->
                            <div class="row mt-2">
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="sdtk_agree_security">
                                        You acknowledge and agree to comply with the Motor Vehicle Security Requirements and the Building Security Requirements <span class="text-danger">*</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="sdtk_agree_owner_payment">
                                        You understand that if you are not the legal owner, any claim payment will be made to the legal owner <span class="text-danger">*</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="sdtk_agree_no_riding_establishment">
                                        You agree that the insured saddlery & tack is not used in connection with a riding establishment or the hiring out of a horse <span class="text-danger">*</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-12">
                                    <mat-checkbox formControlName="sdtk_agree_under_insurance">
                                        You acknowledge and understand the Under Insurance clause as detailed in the policy wording <span class="text-danger">*</span>
                                    </mat-checkbox>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>

            <!-- EXCESS PROTECT COVER SECTION -->
            <div class="mt-4" *ngIf="showAmlinAddonProducts && (isNewQuote || !isQuoteComplete) && !epQuoteId">
                <h4>Excess Protect Cover</h4>
                <div class="form_sections">
                    <div class="row">
                        <div class="col-md-12">
                            <mat-checkbox formControlName="include_ep"
                                (change)="onIncludeEPChange($event.checked)">
                                Add Excess Protect Cover to this quote
                            </mat-checkbox>
                        </div>
                    </div>
                    <div *ngIf="includeEP" class="mt-3">
                        <div class="green_border_panel">
                            <div class="row align-items-center">
                                <div class="col-md-5">
                                    <h6 class="text-white mb-0">Select Cover Option <span class="text-danger">*</span></h6>
                                </div>
                                <div class="col-md-7">
                                    <mat-form-field class="w-100 sdtk-select-field">
                                        <mat-label>Excess Protect Cover</mat-label>
                                        <mat-select formControlName="ep_cover_id" required
                                            (selectionChange)="onEpCoverChange($event)"
                                            [ngClass]="{ 'is-invalid': (f.ep_cover_id.touched || submitted) && f.ep_cover_id.errors?.required }">
                                            <mat-option *ngFor="let opt of epOptions" [value]="opt.id">
                                                {{ opt.name }} - &pound;{{ opt.rate_incl_ipt | number:'1.2-2' }}
                                            </mat-option>
                                        </mat-select>
                                        <div class="invalid-feedback"
                                            *ngIf="(f.ep_cover_id.touched || submitted) && f.ep_cover_id.errors?.required">
                                            Please select a cover option.
                                        </div>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <!-- Premium Breakdown -->
                        <div class="row mt-3" *ngIf="selectedEpOption">
                            <div class="col-md-12">
                                <div class="sdtk-premium-summary">
                                    <div class="row">
                                        <div class="col-md-4 text-center sdtk-premium-summary__item">
                                            <div class="sdtk-premium-summary__label">Premium (excl IPT)</div>
                                            <div class="sdtk-premium-summary__value">&pound;{{ selectedEpOption.rate_excl_ipt | number:'1.2-2' }}</div>
                                        </div>
                                        <div class="col-md-4 text-center sdtk-premium-summary__item">
                                            <div class="sdtk-premium-summary__label">IPT</div>
                                            <div class="sdtk-premium-summary__value">&pound;{{ (selectedEpOption.rate_incl_ipt - selectedEpOption.rate_excl_ipt) | number:'1.2-2' }}</div>
                                        </div>
                                        <div class="col-md-4 text-center sdtk-premium-summary__item sdtk-premium-summary__item--total">
                                            <div class="sdtk-premium-summary__label">Total (incl IPT)</div>
                                            <div class="sdtk-premium-summary__value">&pound;{{ selectedEpOption.rate_incl_ipt | number:'1.2-2' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- CONTACT DETAILS FOR ADDON PRODUCTS -->
            <div class="mt-4" *ngIf="showAmlinAddonProducts && (isNewQuote || !isQuoteComplete) && ((includeSDTK && !sdtkQuoteId) || (includeEP && !epQuoteId))">
                <h4>Contact Details for Add-on Products</h4>
                <div class="form_sections">
                    <div class="row">
                        <div class="col-md-6">
                            <label>Phone <span class="text-danger">*</span></label>
                            <input type="text" class="form-control form-control-sm" placeholder="Enter phone number"
                                formControlName="addon_phone"
                                [ngClass]="{ 'is-invalid': (f.addon_phone.touched || submitted) && f.addon_phone.errors?.required }">
                            <div class="invalid-feedback"
                                *ngIf="(f.addon_phone.touched || submitted) && f.addon_phone.errors?.required">
                                Phone number is required.
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label>Email <span class="text-danger">*</span></label>
                            <input type="email" class="form-control form-control-sm" placeholder="Enter email address"
                                formControlName="addon_email"
                                [ngClass]="{ 'is-invalid': (f.addon_email.touched || submitted) && (f.addon_email.errors?.required || f.addon_email.errors?.email) }">
                            <div class="invalid-feedback"
                                *ngIf="(f.addon_email.touched || submitted) && f.addon_email.errors?.required">
                                Email is required.
                            </div>
                            <div class="invalid-feedback"
                                *ngIf="(f.addon_email.touched || submitted) && f.addon_email.errors?.email">
                                Please enter a valid email address.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- SAVE ERRORS -->
            <div class="mt-3" *ngIf="saveErrors && saveErrors.length > 0">
                <div class="alert alert-warning">
                    <h5>Warnings</h5>
                    <ul class="mb-0">
                        <li *ngFor="let err of saveErrors">{{ err.product }}: {{ err.message }}</li>
                    </ul>
                </div>
            </div>

            <div class="row" *ngIf="!isBroker">
                <div class="col-md-12 mb-3">
                    <label>Refer Reason</label>
                    <textarea name="refer_reason" class="form-control" formControlName="refer_reason" required
                    (change)="onReferReasonChange($event)"
                    [ngClass]="{ 'is-invalid': (f.refer_reason.touched || submitted) && f.refer_reason.errors?.required }"></textarea>
                    <div class="invalid-feedback"
                        *ngIf="(f.refer_reason.touched || submitted) && f.refer_reason.errors?.required">
                        Please enter some notes.
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6  text-right">
                    <button type="submit" class="btn btn-success btn-sm" [disabled]="isSaving" (click)="setReferAndExit(false)">
                        <span *ngIf="isSaving" class="spinner-border spinner-border-sm mr-1"></span>
                        {{btn_text}}
                    </button>
                    <button type="submit" class="btn btn-success btn-sm ml-2" *ngIf="!isBroker" [disabled]="isSaving" (click)="setReferAndExit(true)">Refer and Exit</button>
                </div>
            </div>

        </div>
        <div class="col-md-4">
            <div class="calculator mt-4" style="position: relative;width: 100%;top: 0;right: 0;">
                <mat-accordion>
                    <mat-expansion-panel expanded>
                        <mat-expansion-panel-header class="m-0">
                            <mat-panel-title class="cal_header m-0">
                                Premium
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="cal_body p-3 bg-white">
                            <p>
                                <b>Vehicle Insurance (exc IPT):</b><br>&pound;{{ (premiums?gross_premium - (premiums.ipt):0) | number:'1.2-2' }}
                            </p>
                            <p>
                                <b>Vehicle IPT</b><br>&pound;{{premiums.ipt | number:'1.2-2'}}
                            </p>
                            <p>
                                <b>Breakdown Cover (exc IPT)</b><br>&pound;{{ (premiums.breakdown_gross - premiums.breakdown_ipt) | number:'1.2-2' }}
                            </p>
                            <p>
                                <b>Breakdown IPT</b><br>&pound;{{ premiums.breakdown_ipt | number:'1.2-2' }}
                            </p>
                            <p>
                                <b>Total exc IPT</b><br>&pound;{{ (premiums?((gross_premium - premiums.ipt) + (premiums.breakdown_gross - premiums.breakdown_ipt)):0) | number:'1.2-2' }}
                            </p>
                            <p>
                                <b>Total IPT amount</b><br>&pound;{{ (premiums?premiums.ipt + premiums.breakdown_ipt:0) | number:'1.2-2' }}
                            </p>
                            <p>
                                <b>Total Premium inc IPT</b><br>&pound;{{ total_prem_inc_ipt | number:'1.2-2' }}
                            </p>
                            <p>
                                <b>Peliwica Fee</b><br>&pound;{{peliwica_fee}}
                            </p>
                            <div class="mb-2" *ngIf="modelObj.is_send_email == 1">
                                <b>Broker Fee</b><br>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text dark-green-bg text-white">&pound;</span>
                                    </div>
                                    <input type="number" class="form-control form-control-sm"
                                        required name="broker_admin_fee" formControlName="broker_admin_fee" 
                                        (change)="onBrokerCommissionChange($event)" [readonly]="isBroker"
                                        [ngClass]="{ 'is-invalid': (f.broker_admin_fee.touched || submitted) && f.broker_admin_fee.errors?.required }">
                                    <div class="invalid-feedback"
                                        *ngIf="(f.broker_admin_fee.touched || submitted) && f.broker_admin_fee.errors?.required">
                                        Broker commission is required.
                                    </div>
                                </div>
                            </div>
                            
                            <p>
                                <b>Amlin Total (inc IPT & Fee)</b><br>&pound;{{total_amount | number:'1.2-2'}}
                            </p>
                            <!-- ST Premium -->
                            <div *ngIf="includeSDTK && selectedSdtkOption" class="mt-2 pt-2" style="border-top: 1px solid #dee2e6;">
                                <p class="mb-1">
                                    <b>Saddlery & Tack (incl IPT)</b><br>&pound;{{ sdtkAdjustedTotalInclIpt | number:'1.2-2' }}
                                </p>
                            </div>
                            <!-- EP Premium -->
                            <div *ngIf="includeEP && selectedEpOption" class="mt-2 pt-2" style="border-top: 1px solid #dee2e6;">
                                <p class="mb-1">
                                    <b>Excess Protect (incl IPT)</b><br>&pound;{{ selectedEpOption.rate_incl_ipt | number:'1.2-2' }}
                                </p>
                            </div>
                            <!-- Combined Total -->
                            <div *ngIf="(includeSDTK && selectedSdtkOption) || (includeEP && selectedEpOption)" class="mt-2 pt-2" style="border-top: 2px solid #28a745;">
                                <p>
                                    <b style="color: #28a745;">Combined Total Payable</b><br>
                                    <b style="font-size: 1.1em;">&pound;{{ getCombinedTotal() | number:'1.2-2' }}</b>
                                </p>
                            </div>
                            <p *ngIf="vehicle_premiums_key">
                                <b><u>Rate per Vehicle</u></b><br>
                            </p>
                            <div class="row" *ngIf="vehicle_premiums_key">
                                <div class="col-6">
                                    <b>{{ vehicle_premiums_key }}</b>
                                </div>
                                <div class="col-6">
                                    &pound;{{ vehicle_premiums_value }}
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-12" *ngIf="!isBroker">
                                    <b>Commission</b><br>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text dark-green-bg text-white">%</span>
                                        </div>
                                        <input type="number" class="form-control form-control-sm" placeholder="20"
                                            required name="commission" formControlName="commission" min="0" max="20"
                                            (change)="onCommissionChange($event)"
                                            [ngClass]="{ 'is-invalid': (f.commission.touched || submitted) && f.commission.errors?.required }">
                                        <div class="invalid-feedback"
                                            *ngIf="(f.commission.touched || submitted) && f.commission.errors?.required">
                                            Commission is required.
                                        </div>
                                    </div>
                                </div>
                              
                                <!-- <div class="col-md-12 mt-2" *ngIf="modelObj.type == 1">
                                    <b>Discount(Max 10%)</b><br>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text dark-green-bg text-white">%</span>
                                        </div>
                                        <input type="number" class="form-control form-control-sm" placeholder="Discount(Max 10%)"
                                            required name="discount" formControlName="discount" min="0" max="10"
                                            (change)="onDiscountChange($event)"
                                            [ngClass]="{ 'is-invalid': (f.discount.touched || submitted) && f.discount.errors?.required }">
                                        <div class="invalid-feedback"
                                            *ngIf="(f.discount.touched || submitted) && f.discount.errors?.required">
                                            Discount is required.
                                        </div>
                                    </div>
                                </div> -->
                            </div>

                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <div class="form_sections mt-3">
                <h4>Quote Summary</h4>
                <hr>
                <div class="row" *ngIf="calErrors && calErrors.length > 0 && attention_required_text == ''">
                    <div class="col-md-12">
                        <div class="alert alert-danger">
                            <h4>Attention Required</h4>
                            <ul>
                                <li *ngFor="let e of calErrors">
                                    {{ (e.detail)?e.detail:e.title }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="attention_required_text != ''">
                    <div class="col-md-12">
                        <div class="alert alert-danger">
                            <h4>Attention Required</h4>
                            <ul>
                                <li>{{attention_required_text}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 fw-300">Countrywise</div>
                    <div class="col-md-7 fw-500">Horsebox</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Reference</div>
                    <div class="col-md-7 fw-500">{{ reference }}</div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Cover Dates</div>
                    <div class="col-md-7 fw-500">{{ cover_period }} </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-5 fw-300">Customer Type</div>
                    <div class="col-md-7 fw-500 text-capitalize">{{ proposer_type }}</div>
                </div>
                <hr>
                <a href="{{ policy_wording_doc_url }}" target="_blank" class="btn btn-success btn-sm w-100">Policy
                    Wording</a><br>
                <a href="{{ breakdown_wording_doc_url }}" target="_blank"
                    class="btn btn-success btn-sm w-100 mt-2">Breakdown Wording</a><br>
                <a href="{{ ipid_wording_doc_url }}" target="_blank" class="btn btn-success btn-sm w-100 mt-2">IPID</a>
                <a *ngIf="sdtkQuoteId" [routerLink]="['/sdtk/quote-details', sdtkQuoteId]" class="btn btn-info btn-sm w-100 mt-2">View SDTK Quote</a>
                <a *ngIf="epQuoteId" [routerLink]="['/excess-protect/quote-details', epQuoteId]" class="btn btn-info btn-sm w-100 mt-2">View Excess Protect Quote</a>
                <!-- <div class="row mt-3">
                <div class="col-md-5 fw-300">Insured</div>
                <div class="col-md-7 fw-500"></div>
            </div>
            <div class="row mt-3">
                <div class="col-md-5 fw-300">Driver(s)</div>
                <div class="col-md-7 fw-500"></div>
            </div> -->
            </div>
        </div>
    </div>
</form>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="helptext" [innerHTML]="helptext"></div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
    </div>
</ng-template>
<ng-template #referral let-modal>
    <div class="modal-body">
        <div class="helptext">Clicking save will send your quote to the underwriter, the quote will then be locked for
            editing until the underwriter decision has been made. If you need to edit your quote please do so before
            clicking save.</div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-dark" (click)="modal.close()">Exit</button>
        <button type="button" class="btn btn-success" (click)="saveQuote(content)">Save</button>
    </div>
</ng-template>

<!-- <p>
    Form is {{frmFields.valid ? 'Valid' : 'Invalid'}}
</p>
<pre>
            {{frmFields.value | json}}
            </pre>  -->